import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { Od260Calc } from "../components/Od260Calc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.od_tool_name()}
        toolPath="/od260-concentration"
      />
      <SciHeader title={m.od_h1()} intro={m.od_intro()} />

      <Od260Calc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.od_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.od_ex1(), m.od_ex2(), m.od_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.od_faq_q1(), a: m.od_faq_a1() },
          { q: m.od_faq_q2(), a: m.od_faq_a2() },
          { q: m.od_faq_q3(), a: m.od_faq_a3() },
          { q: m.od_faq_q4(), a: m.od_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
